/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_ALL_ANOMALOUS_APPLICATIONS_RESPONSE = [
	{
		first: true,
		last: false,
		size: 10,
		totalElements: 11,
		totalPages: 2,
		number: 0,
		contents: [
			{
				applicationId: "AWS Application",
				anomaliesAmount: 100,
				totalCo2: 25.569956488
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50.45668255
			},
			{
				applicationId: "AWS Application",
				anomaliesAmount: 100,
				totalCo2: 25.5685845
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50.4789865
			},
			{
				applicationId: "AWS Application",
				anomaliesAmount: 100,
				totalCo2: 25
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50
			},
			{
				applicationId: "IBM Cloud Application",
				anomaliesAmount: 20,
				totalCo2: 50
			}
		]
	},
	{
		first: false,
		last: true,
		size: 10,
		totalElements: 11,
		totalPages: 2,
		number: 1,
		contents: [
			{
				applicationId: "AWS Application",
				anomaliesAmount: 100,
				totalCo2: 25.569956488
			}
		]
	}
];

export const GET_ANOMALIES_BY_APPLICATION_RESPONSE = {
	pages: [
		{
			first: true,
			last: false,
			size: 10,
			totalElements: 11,
			totalPages: 2,
			number: 0,
			contents: [
				{
					applicationId: "AWS Application",
					layerId: "EC2 Machine Learning",
					timestamp: "2023-10-24T14:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.75547
				},
				{
					applicationId: "Azure Application",
					layerId: "Azure ML",
					timestamp: "2023-10-24T15:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.65456
				},
				{
					applicationId: "GCP Application",
					layerId: "Compute Engine Machine Learning",
					timestamp: "2023-10-24T16:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.854152
				},
				{
					applicationId: "AWS Application",
					layerId: "EC2 Machine Learning",
					timestamp: "2023-10-24T17:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.955874
				},
				{
					applicationId: "Azure Application",
					layerId: "Azure ML",
					timestamp: "2023-10-24T18:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.5547565
				},
				{
					applicationId: "GCP Application",
					layerId: "Compute Engine Machine Learning",
					timestamp: "2023-10-24T19:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.4574855
				},
				{
					applicationId: "AWS Application",
					layerId: "EC2 Machine Learning",
					timestamp: "2023-10-24T20:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.358278
				},
				{
					applicationId: "Azure Application",
					layerId: "Azure ML",
					timestamp: "2023-10-24T21:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.2578278
				},
				{
					applicationId: "Azure Application",
					layerId: "Azure ML",
					timestamp: "2023-10-24T18:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.5547565
				},
				{
					applicationId: "GCP Application",
					layerId: "Compute Engine Machine Learning",
					timestamp: "2023-10-24T19:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.4574855
				}
			]
		},
		{
			first: false,
			last: true,
			size: 10,
			totalElements: 12,
			totalPages: 2,
			number: 1,
			contents: [
				{
					applicationId: "AWS Application",
					layerId: "EC2 Machine Learning",
					timestamp: "2023-10-24T20:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.358278
				},
				{
					applicationId: "Azure Application",
					layerId: "Azure ML",
					timestamp: "2023-10-24T21:00:00.123Z",
					anomalyType: "E",
					anomalyScore: 0.2578278
				}
			]
		}
	],
	sciLineChart: {
		title: "SCI",
		lineSeries: [
			{
				name: "Serie",
				linePoints: [
					{
						name: "2025-03-24T23:00",
						value: 0.0023128973591296106,
						unit: ""
					},
					{
						name: "2025-03-25T00:00",
						value: 0.0025224536259948324,
						unit: ""
					},
					{
						name: "2025-03-25T02:00",
						value: 0.0007337892855727708,
						unit: ""
					},
					{
						name: "2025-03-25T03:00",
						value: 0.0007032363115411947,
						unit: ""
					},
					{
						name: "2025-03-25T04:00",
						value: 0.0024415279554944585,
						unit: ""
					},
					{
						name: "2025-03-25T05:00",
						value: 0.0004971859848024875,
						unit: ""
					},
					{
						name: "2025-03-25T06:00",
						value: 0.0003768968098778977,
						unit: ""
					},
					{
						name: "2025-03-25T07:00",
						value: 0.021113817021505027,
						unit: ""
					},
					{
						name: "2025-03-25T09:00",
						value: 0.020222431510635498,
						unit: ""
					},
					{
						name: "2025-03-25T10:00",
						value: 0.0004287292669990511,
						unit: ""
					},
					{
						name: "2025-03-25T11:00",
						value: 0.0002447837840185884,
						unit: ""
					},
					{
						name: "2025-03-25T13:00",
						value: 0.004894879698495135,
						unit: ""
					},
					{
						name: "2025-03-25T14:00",
						value: 0.0011234684172575277,
						unit: ""
					}
				]
			}
		]
	},
	co2LineChart: {
		title: "CO2",
		lineSeries: [
			{
				name: "Serie",
				linePoints: [
					{
						name: "2025-03-24T23:00",
						value: 0.039463997438890036,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T00:00",
						value: 0.006119330385848909,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T02:00",
						value: 0.005752012088355064,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T03:00",
						value: 0.005630318101043703,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T04:00",
						value: 0.005471925021845918,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T05:00",
						value: 0.005827140769989755,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T06:00",
						value: 0.005915232301418832,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T07:00",
						value: 0.04353700172867469,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T09:00",
						value: 0.0061621328885257485,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T10:00",
						value: 0.006089976926845653,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T11:00",
						value: 0.006256755451433088,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T13:00",
						value: 0.005519220171870793,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T14:00",
						value: 0.006162132888525749,
						unit: "KgCo2e"
					}
				]
			}
		]
	},
	sciComponentELineChart: {
		title: "E",
		lineSeries: [
			{
				name: "Serie",
				linePoints: [
					{
						name: "2025-03-24T23:00",
						value: 0.0003609511960874089,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T00:00",
						value: 0.00005596948523642296,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T02:00",
						value: 0.00005260986666178413,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T03:00",
						value: 0.00005149681189978997,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T04:00",
						value: 0.000050048094712005355,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T05:00",
						value: 0.00005329701923771118,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T06:00",
						value: 0.00005410273446419664,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T07:00",
						value: 0.00039820428410373195,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T09:00",
						value: 0.00005636097154139405,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T10:00",
						value: 0.00005570100847724683,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T11:00",
						value: 0.000057226421811888,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T13:00",
						value: 0.00005048067230369628,
						unit: "KgCo2e"
					},
					{
						name: "2025-03-25T14:00",
						value: 0.00005636097154139405,
						unit: "KgCo2e"
					}
				]
			}
		]
	}
};
